export default "__VITE_ASSET__B_DG3tYl__"